// extracted by mini-css-extract-plugin
export default {"container":"AgendaItem_container__VQBmu","timeframe":"AgendaItem_timeframe__gHQx8","description":"AgendaItem_description__UdUE4"};